import { render, staticRenderFns } from "./ConnectionLostDialog.vue?vue&type=template&id=28c053ca&scoped=true"
import script from "./ConnectionLostDialog.vue?vue&type=script&lang=js"
export * from "./ConnectionLostDialog.vue?vue&type=script&lang=js"
import style0 from "./ConnectionLostDialog.vue?vue&type=style&index=0&id=28c053ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c053ca",
  null
  
)

export default component.exports